
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { useClientInformationRepository } from '../services/clientInformationRepository';
import { useRef, useState } from 'react';
import { usePricePerClient } from '../hooks/usePricePerClient';
import { Table } from '@vadiun/react-datatable';
import { MUIDataTableColumnDef } from 'mui-datatables';
import RefreshList from 'shared/components/Table/Refresh';

export const PricePerClientPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [searchValue, setSearchValue] = useState<string>('');

  const repo = useClientInformationRepository();
  const {
    pricePerClient,
    reload,
    filters,
    onChangePage,
    onChangeRowsPerPage,
    onSortChange,
    onFiltersChange,
    handleSearchChange
  } = usePricePerClient();

  const data =( pricePerClient.data?? []) .map((x) => ({
    ...x,
    ejecutivo: Number(x.ejecutivo || 0),
    mensajeria: Number(x.mensajeria || 0),
    utilitario: Number(x.utilitario || 0),
    flete: Number(x.flete || 0),
    vip: Number(x.vip || 0),
    comisionBase: Number(x.comisionBase || 0),
    comisionExcedente: Number(x.comisionExcedente),
    limiteComisionBase: Number(x.limiteComisionBase),
    kmMinPrice: x.kmMinPrice ? Number(x.kmMinPrice) : 0,
    hourWaitingPrice: x.hourWaitingPrice ? Math.round(Number(x.hourWaitingPrice)) : 0,
  }));
  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'client',
      label: 'Cliente',
      options: {
        filterType: 'multiselect',
      }
    },
    {
      name: 'kmMin',
      label: 'Km Mínimo ',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'kmMinPrice',
      label: 'Km Mínimo $',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'hourWaitingPrice',
      label: 'Espera $/h',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'vtoActual',
      label: 'Vencimiento Actual',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'vtoAnterior',
      label: 'Vencimiento Anterior',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'precioOutsite',
      label: 'Precio Outsite',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'item',
      label: 'Item',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'ejecutivo',
      label: 'Ejecutivo',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'vip',
      label: 'VIP',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'utilitario',
      label: 'Utilitario',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'mensajeria',
      label: 'Mensajeria',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'flete',
      label: 'Flete',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'comisionBase',
      label: 'Comisión Base',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'limiteComisionBase',
      label: 'Limite Comisión Base',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: 'comisionExcedente',
      label: 'Comisión Excedente',
      options: {
        filter: false,
        sort: false
      }
    }
  ];


  const handleSearchChangeTable = (search: string | null) => {
    setSearchValue(search || '');
    handleSearchChange(search || null);
  };


  return (
    <div ref={tableRef}>
      <PageHeader title="Precios por Cliente" area=" Estadísticas" />
      <div
        className="sticky top-0 right-0 left-0 flex flex-col "
        style={{
          zIndex: 101,
          background: '#EAEDF5',
          // border: '1px solid rgba( 255, 255, 255, 0.18 )',
          marginBottom: '-24px'
        }}
      >
        <div className="flex w-full px-8 mt-2">
          <div
            className="flex justify-end items-center px-2 w-full rounded-t-lg"
            style={{ backgroundColor: '#00163B' }}
          >
            <div className="flex justify-end py-1 px-4 w-fit">
              <RefreshList
                onRefreshTable={() => reload()}
                isRefreshing={pricePerClient.isLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <PageContainer lessMargin={true}>
        <div className="h-full w-full">
        <Table
        title={''}
        data={data}
        options={{
          elevation: 0,
          selectableRows: 'none',
          search: true,
          searchOpen: searchValue !== '',
          searchText: searchValue,
          filter: false,
          print: false,
          viewColumns: false,
          pagination: false,
          rowsPerPageOptions: [],
          downloadOptions: {
            filename: 'precios_por_cliente.csv',
            separator: ',',
          },
       
        
          onColumnSortChange: (
            changedColumn: string,
            direction: 'asc' | 'desc'
          ) => {
            onSortChange(direction, changedColumn);
          },
          onSearchChange: handleSearchChangeTable,
          ...pricePerClient.serverSideOptions
        }}
        columns={columns}
      />
        </div>
      </PageContainer>
    </div>
  );
};
